import './LoadingSpinner.scss';

import React from 'react';

export default class LoadingSpinner extends React.Component {
    render() {
        return (
            <div className="loading-spinner--wrapper">
                <div className="loading-spinner">
                    <svg viewBox="0 0 100 100">
                        <circle fill="#49688f" cx="50" cy="50" r="50"/>
                        <g className="loading-spinner__animate" fill="#ffffff">
                            <path d="M81.43,50H78.91a28.91,28.91,0,0,0-57.83,0H18.57a31.43,31.43,0,0,1,62.86,0Z"/>
                            <path d="M94,50H91.49a41.49,41.49,0,0,0-83,0H6a44,44,0,0,1,88,0Z"/>
                        </g>
                        <circle fill="#ffffff" cx="50" cy="49.49" r="12.57"/>
                    </svg>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/index.js